import {ConjugationViewProps} from "../components/ConjugationView";
import {useDutchConjugation} from "../languages/dutch/hooks/useDutchConjugation";
import {useJapaneseConjugation} from "../languages/japanese/hooks/useJapaneseConjugation";

export function useConjugation({word, language}: ConjugationViewProps) {

    const {hasConjugationInfo: hasDutchConjugationInfo, posWithTagging: dutchPosWithTagging} = useDutchConjugation({word, language});
    const {hasConjugationInfo: hasJapaneseConjugationInfo, posWithTagging: japanesePosWithTagging} = useJapaneseConjugation({word, language});

    const hasConjugationInfo =
        language == "Dutch" ? hasDutchConjugationInfo :
        language == "Japanese" ? hasJapaneseConjugationInfo :
        false;

    const posWithTagging =
        language == "Dutch" ? dutchPosWithTagging :
        language == "Japanese" ? japanesePosWithTagging :
        null;

    return {
        hasConjugationInfo,
        posWithTagging
    }

}